import { render, staticRenderFns } from "./right.vue?vue&type=template&id=c5bee6a8&scoped=true&"
import script from "./right.vue?vue&type=script&lang=js&"
export * from "./right.vue?vue&type=script&lang=js&"
import style0 from "./right.vue?vue&type=style&index=0&id=c5bee6a8&lang=scss&scoped=true&"
import style1 from "./right.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bee6a8",
  null
  
)

export default component.exports